module.exports = __webpack_public_path__ + "img/training_course_2.e5241c56.jpg";